module.exports = __webpack_public_path__ + "img/blank_profile.28000836.svg";